import React, {PureComponent} from "react"
import MFA from "@irati/auth/utils/mfa"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import RequestCode from "./Request"
import MFASetup from "./Setup"
import EnterCode from "./EnterCode"

export enum Screens {
  REQUEST = "REQUEST",
  SETUP = "SETUP",
  ENTER = "ENTER"
}

const modals = [Screens.REQUEST, Screens.SETUP, Screens.ENTER]

interface ExtraData {
  phoneNumber: string
}

export type selectScreen = (screen: Screens | null, extraData?: ExtraData) => void

interface Props {}
interface State {
  screen: Screens,
  extraData?: ExtraData
}

export default class MFAPopup extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      screen: modalStory(modals, null)
    }
  }

  componentDidMount() {
    MFA.addEventListener(this.handleMFAStateChange)
  }

  handleMFAStateChange = () => {
    this.setState({screen: modalStory(modals, Screens.REQUEST)})
  }

  selectScreen: selectScreen = (screen, extraData) => {
    this.setState({screen: modalStory(modals, screen), extraData})
  }

  handleCancel = () => {
    MFA.cancel()
    this.selectScreen(null)
  }

  render() {
    const {screen, extraData} = this.state

    if (!anyStoriesOpen(screen)) {
      return null
    }

    let phoneNumber = ""
    if (extraData && extraData.phoneNumber) {
      phoneNumber = extraData.phoneNumber
    }

    return (
      <>
        <RequestCode show={screen[Screens.REQUEST]} onCancel={this.handleCancel} selectScreen={this.selectScreen} />
        <MFASetup show={screen[Screens.SETUP]} onCancel={this.handleCancel} selectScreen={this.selectScreen} />
        <EnterCode show={screen[Screens.ENTER]} onCancel={this.handleCancel} selectScreen={this.selectScreen} phoneNumber={phoneNumber} />
      </>
    )
  }
}
